import { TermType } from '@/types/models'

export type FACET_PAGE_TYPE = `${string}+${TermType}`

export const facetsMap = {
  treatment_therapy: 'treatment_therapies',
  new_specialization: 'new_specializations',
  treatment_method: 'treatment_methods'
}

export const getFacetFromPageType = (
  pageType: FACET_PAGE_TYPE
): TermType | '' => {
  const facet = pageType.split('+')[1]

  return facetsMap[facet] || facet || ''
}
